import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import { DescriptionList, Flex, Link, Text } from '@applyboard/crystal-ui';
import { Copyable } from "../../../../../components/Copyable";
import { SideBarDescriptionList } from "../SideBarDescriptionList";
import { useApplication, useOrderItem } from "../../../data";
import { CheckCircleIcon } from '@applyboard/ui-icons';
import { useTranslation } from '@applyboard/ui-utils';
import { assert } from "../../../../../utils/assert";
import { useSideBarEventTracker } from "../../../utils/eventTracking";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export var PaymentDetails = function PaymentDetails(_ref) {
  var copyEnabled = _ref.copyEnabled,
    hideOrderLink = _ref.hideOrderLink;
  var _useTranslation = useTranslation('PaymentDetails'),
    t = _useTranslation.t;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useOrderItem = useOrderItem(),
    orderItem = _useOrderItem.orderItem;
  assert(orderItem, 'OrderItem not found in aggregated data.');
  var finalCost = getFinalCost(orderItem);
  var originalCost = orderItem.cost.amount;
  return _jsxs(SideBarDescriptionList, {
    children: [_jsx(DescriptionList.Term, {
      children: t('applicationFee')
    }), _jsx(DescriptionList.Details, {
      children: _jsxs(Flex, {
        direction: "row",
        gap: 2,
        children: [originalCost !== finalCost && _jsx(Text, {
          contrast: "mid",
          overflow: "nowrap",
          children: _jsx(Copyable, {
            disabled: !copyEnabled,
            children: _jsx("s", {
              children: formatCurrency(originalCost, orderItem.cost.currency)
            })
          })
        }), _jsx(Text, {
          overflow: "nowrap",
          children: _jsx(Copyable, {
            disabled: !copyEnabled,
            children: formatCurrency(finalCost, orderItem.cost.currency)
          })
        })]
      })
    }), _jsx(DescriptionList.Term, {
      children: t('paymentStatus')
    }), _jsx(DescriptionList.Details, {
      children: application.paidAt ? _jsxs(Flex, {
        direction: "row",
        gap: 2,
        children: [_jsx(CheckCircleIcon, {
          variant: "fill",
          intent: "positive"
        }), _jsx(Copyable, {
          disabled: !copyEnabled,
          children: t('paid')
        })]
      }) : _jsx(Copyable, {
        disabled: !copyEnabled,
        children: t('unpaid')
      })
    }), _jsx(DescriptionList.Term, {
      children: t('paymentDate')
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: application.paidAt ? new Date(application.paidAt).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        }) : '--'
      })
    }), application.paidAt && _jsx(ReceiptLinkRow, {
      copyEnabled: copyEnabled,
      orderId: orderItem.orderId
    }), !hideOrderLink && application.paidAt && _jsx(MangeOrderLinkRow, {
      copyEnabled: copyEnabled,
      orderId: orderItem.orderId
    })]
  });
};
function ReceiptLinkRow(_ref2) {
  var orderId = _ref2.orderId,
    copyEnabled = _ref2.copyEnabled;
  var _useTranslation2 = useTranslation('PaymentDetails'),
    t = _useTranslation2.t;
  var trackEvent = useSideBarEventTracker();
  assert(orderId, 'Order ID is required to display receipt link');
  return _jsxs(_Fragment, {
    children: [_jsx(DescriptionList.Term, {
      children: t('receipt')
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: _jsx(Link, {
          download: "receipt-".concat(orderId, ".pdf"),
          href: "".concat(window.location.origin, "/api/payments/v1/receipts/application-fee/").concat(orderId, "?branded=false"),
          onClick: function onClick() {
            trackEvent({
              event: 'Payment Details - Clicked To See Receipt'
            });
          },
          children: t('downloadReceipt')
        })
      })
    })]
  });
}
function MangeOrderLinkRow(_ref3) {
  var orderId = _ref3.orderId,
    copyEnabled = _ref3.copyEnabled;
  var _useTranslation3 = useTranslation('PaymentDetails'),
    t = _useTranslation3.t;
  var trackEvent = useSideBarEventTracker();
  assert(orderId, 'Order ID is required to display manage order link');
  return _jsxs(_Fragment, {
    children: [_jsx(DescriptionList.Term, {
      children: t('order')
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: _jsx(Link, {
          href: "/orders/".concat(orderId, "/receipt"),
          onClick: function onClick() {
            trackEvent({
              event: 'Payment Details - Clicked To Manage Order'
            });
          },
          children: t('manageOrder')
        })
      })
    })]
  });
}
function getFinalCost(item) {
  var originalCost = item.cost.amount;
  function calculateSum(items) {
    return (items === null || items === void 0 ? void 0 : items.reduce(function (acc, item) {
      var _item$cost;
      return item !== null && item !== void 0 && (_item$cost = item.cost) !== null && _item$cost !== void 0 && _item$cost.amount ? acc + (item === null || item === void 0 ? void 0 : item.cost.amount) : 0;
    }, 0)) || 0;
  }
  var creditsSum = calculateSum(item.credits || []);
  var discountsSum = calculateSum(item.discounts || []);
  var finalCost = originalCost - discountsSum + creditsSum;
  return finalCost;
}
function formatCurrency(valueInCents, currency) {
  var userLocale = navigator.language || 'en-US';
  return new Intl.NumberFormat(userLocale, {
    style: 'currency',
    currency: currency
  }).format(valueInCents / 100);
}